import { Empty, Table } from 'antd';
import { useTranslation } from 'react-i18next';

type TableComponentProps = {
  tableData: any;
  columns: any;
  pageSize: number;
  currentPage: number;
  totalItems: number;
  onPaginationChanged: any;
  onSelectionChanged?: any;
  loading?: boolean;
  styleClassNames?: any;
  rowClassName?: any;
  rowHoverable?: boolean;
  showHeader?: boolean;
  size?: 'middle' | 'small' | 'large';
  pageSizeOptions?: string[];
  [key: string]: any;
  renderExpandable?: (record: any) => any;
  isRenderExpandableTrue?: (record: any) => any;
};

const TableComponent = (props: TableComponentProps) => {
  const {
    tableData,
    columns,
    pageSize,
    currentPage,
    totalItems,
    onPaginationChanged,
    onSelectionChanged,
    loading,
    rowClassName,
    rowHoverable,
    showHeader,
    renderExpandable,
    isRenderExpandableTrue,
    styleClassNames = 'mt-5 w-screen',
    pageSizeOptions = ['5', '10', '15', '20', '30', '40'],
    ...rest
  } = props;

  const { t } = useTranslation(['common']);
  const safeTableData = Array.isArray(tableData) ? tableData : [];

  return (
    <Table
      dataSource={safeTableData}
      columns={columns}
      className={styleClassNames}
      size="middle"
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: totalItems,
        showQuickJumper: true,
        locale: {
          jump_to: t('goTo'),
          page: t('page'),
          items_per_page: `/ ${t('page')}`,
        },
        position: ['bottomLeft'],
        showSizeChanger: true,
        onChange: onPaginationChanged,
        pageSizeOptions: pageSizeOptions,
        showTotal: (total, range) => `${range[0]}-${range[1]} ${t('of')} ${total}`,
      }}
      onRow={
        onSelectionChanged
          ? (record: any) => {
              return {
                onClick: () => {
                  onSelectionChanged(record);
                },
                className: 'cursor-pointer hover:bg-primary-light-gray transition',
              };
            }
          : undefined
      }
      rowClassName={rowClassName}
      rowHoverable={rowHoverable}
      showHeader={showHeader}
      loading={loading}
      locale={{
        emptyText: (
          <Empty
            className="bg-gray-bg-color py-5"
            description={safeTableData.length === 0 ? t('noData') : null}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        ),
      }}
      expandable={{
        expandedRowRender: (record) => renderExpandable?.(record),
        rowExpandable: (record) => isRenderExpandableTrue?.(record),
      }}
      {...rest}
    />
  );
};

export default TableComponent;
